import { TranslationMap } from '@trimble-gcs/i18n-types';

export function multiSelectedTranslations() {
  return {
    confirmDeleteDialog: {
      title: {
        text: $localize`:@@multiSelected.confirmDeleteDialog.title:Delete {Reality Capture} Data`,
        desc:
          'Title of the multiple item delete confirmation dialog. ' +
          "The term 'Reality Capture' is the product name and is not translated.",
      },
      message: {
        text: $localize`:@@multiSelected.confirmDeleteDialog.message:Are you sure you want to move these {count} items to the recycle bin?`,
        desc: 'Confirmation message shown when recycling multiple items. The {count} value will always be larger than one.',
      },
      delete: {
        text: $localize`:@@multiSelected.confirmDeleteDialog.delete:Recycle`,
        desc: 'Button text to confirm recycle.',
      },
    },
    deleteErrorDialog: {
      title: {
        text: $localize`:@@multiSelected.deleteErrorDialog.title:Recycle Error`,
        desc: 'Title of the error dialog when there was a failure to move items to the recycling bin.',
      },
      message: {
        '=1': {
          text: $localize`:@@multiSelected.deleteErrorDialog.message.one:The following scan failed to recycle: {names}`,
          desc: 'Error message shown when a single item failed to recycle. {names} will contain a single item name.',
        },
        other: {
          text: $localize`:@@multiSelected.deleteErrorDialog.message.other:The following scans failed to recycle: {names}`,
          desc: 'Error message shown when a multiple items failed to recycle. {names} are delimited with a new line.',
        },
      },
      dismiss: {
        text: $localize`:@@multiSelected.deleteErrorDialog.dismiss:Dismiss`,
        desc: 'Button text to dismiss the recycle error dialog.',
      },
    },
  } satisfies TranslationMap;
}
